import { statusSubCampaign, actionTakenSubCampaign } from '@/helpers/constants';
import { Step } from '@/types';

export const getStautsIconClassName = (step: Step) => {
  // styles of custom color chips in App.scss
  let className = 'di icon-kreis-loeschen NonSuccess';

  if (!step.actionLedToNonSuccessfulStatus
    && ![statusSubCampaign.IN_PLANT_VALIDATION, statusSubCampaign.IN_E3_APPROVAL].includes(step.statusCode)) {
    className = 'di icon-kreis-check Success';
  } else if (step.actionTaken === 'REQUESTED_FOR_CHANGES') {
    className = 'di icon-kreis-entscheid-gelb Warning';
  } else if (step.statusCode === statusSubCampaign.IN_PLANT_VALIDATION
    && [actionTakenSubCampaign.CREATED, actionTakenSubCampaign.SENT_TO_ANALYSIS].includes(step.actionTaken)) {
    className = 'di icon-sanduhr'; // sandclock, without color
  } else if (step.statusCode === statusSubCampaign.IN_PLANT_VALIDATION && step.actionTaken === actionTakenSubCampaign.SENT_TO_APPROVAL) {
    className = 'di icon-kreis-check Success';
  } else if (step.statusCode === statusSubCampaign.IN_E3_APPROVAL && step.actionTaken === actionTakenSubCampaign.APPROVED) {
    className = 'di icon-kreis-check Success';
  } else if (step.statusCode === statusSubCampaign.IN_E3_APPROVAL && step.actionTaken === actionTakenSubCampaign.REJECTED) {
    className = 'di icon-kreis-loeschen NonSuccess'; // X, red / rejected
  } else if (step.statusCode === statusSubCampaign.IN_E3_APPROVAL && step.actionTaken === actionTakenSubCampaign.SENT_TO_APPROVAL) {
    className = 'di icon-richterhammer-2'; // martillo juez, / in approval
  }

  return className;
};

export const cc = '';
